var app = angular.module('leonardo');

var OverviewStates = function($stateProvider) {
  $stateProvider.state('overview', {
    url: '/overview',
    parent: 'authenticated.layout-main',
    views: {
      'content@authenticated.layout-main': {
        controller: 'OverviewNewController',
        templateUrl: 'views/templates/overview/new.html'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'FiltersOverviewController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/overview-list.html',
        controller: 'ActionsOverviewController'
      }
    },
    ncyBreadcrumb: {
      skip: 'Overview'
    },
    redirectTo: 'dashboard.overview'
  });

  $stateProvider.state('dashboard', {
    url: '/dashboard',
    parent: 'authenticated.layout-main',
    redirectTo: function (PermissionService) {
      if (PermissionService.permissionAvailableAccount('permission_view_dashboard', true)) {
        return 'dashboard.map';
      }
      else {
        return 'property.tasks';
      }
    },
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'messages': {
        templateUrl: 'views/templates/overview/messages.html',
        controller: 'MessagesController'
      }
    },
    ncyBreadcrumb: {
      label: 'Dashboard'
    }
  });

  $stateProvider.state('dashboard.map', {
    url: '/map',
    cssClass: 'property-dashboard',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/overview/dashboard.html',
        controller: 'DashboardController'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'FiltersOverviewController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/overview-list.html',
        controller: 'ActionsOverviewController'
      }
    },
    ncyBreadcrumb: {
      label: 'Map'
    }
  });

  $stateProvider.state('dashboard.overview', {
    url: '/overview',
    title: 'Overview',
    views: {
      'content@authenticated.layout-main': {
        controller: 'OverviewNewController',
        templateUrl: 'views/templates/overview/new.html'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'FiltersOverviewController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/overview-list.html',
        controller: 'ActionsOverviewController'
      }
    },
    ncyBreadcrumb: {
      label: 'Overview'
    }
  });

};

app.config(['$stateProvider', OverviewStates]);
